import { render, staticRenderFns } from "./GenericContents.vue?vue&type=template&id=44fd13e6&scoped=true"
import script from "./GenericContents.vue?vue&type=script&lang=js"
export * from "./GenericContents.vue?vue&type=script&lang=js"
import style0 from "./GenericContents.vue?vue&type=style&index=0&id=44fd13e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fd13e6",
  null
  
)

export default component.exports